import React from 'react'
import Header from '../components/header'
import Footer from '../components/footer'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

export default function About() {
  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>About Tooliso – Trusted Free Online Tools Platform</title>
        <meta
          name="description"
          content="Learn more about Tooliso – your all-in-one platform for fast, free, and secure online tools. Discover what makes us different."
        />
        <meta property="og:title" content="About Tooliso – Free Utility Tools Online" />
        <meta property="og:description" content="At Tooliso, we simplify online tasks with powerful, easy-to-use tools. Read about our mission, values, and why users trust us." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.tooliso.com/AboutUs" />
        <meta property="og:image" content="https://www.tooliso.com/about-og.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Tooliso – Trusted Free Online Tools" />
        <meta name="twitter:description" content="Get to know Tooliso – a fast-growing free tools hub trusted by thousands. Simple, reliable, secure." />
        <meta name="twitter:image" content="https://www.tooliso.com/twitter-about.jpg" />
      </Helmet>

      <Header />

      <div id="about-us">
        <h1>About Us</h1>
        <p>Welcome to <strong>ToolISO</strong>, your go-to platform for powerful and easy-to-use online tools!</p>

        <p>
          At ToolISO, we believe in making digital tasks simpler, faster, and more efficient. Whether you need to generate,
          convert, edit, or optimize files, our collection of free tools is designed to help you get the job done effortlessly.
        </p>

        <h2>Why Choose ToolISO?</h2>
        <ul>
          <li><strong>✔ Fast &amp; Reliable:</strong> Get instant results without any hassle.</li>
          <li><strong>✔ User-Friendly:</strong> No complicated processes, just simple and effective tools.</li>
          <li><strong>✔ 100% Free:</strong> Enjoy all our tools without any hidden costs.</li>
          <li><strong>✔ Privacy First:</strong> Your data stays safe; we don’t store or share any files.</li>
        </ul>

        <p>
          We’re constantly adding new tools to make your online experience even better. Explore our <Link to={'/'}>homepage</Link>,
          read the latest <Link to={'/Blogs'}>blogs</Link>, or <Link to={'/contact'}>Contact us</Link> to learn more about what we do.
        </p>
      </div>

      <Footer />
    </div>
  )
}